import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function LeadershipSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-114" data-mp="319s9i0ydfnse">
      <div className="max-w-5xl mx-auto" data-id="element-115" data-mp="31761y1bhd8a6">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-116" data-mp="3f0x1cgvhzbs6">
          Liderazgo
        </h2>
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-117" data-mp="3b04ufua3liz2">
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-118" data-mp="2n97tfcjuc62l">
            <div className="flex-shrink-0" data-id="element-119" data-mp="2nbc2e8wljv9q">
              <img src="https://cdn.magicpatterns.com/uploads/7U3hDq8J9KthoV73FcJn55/Andreina_Escalante.jpg" alt="Andreina Escalante Prado, Fundadora" className="w-48 h-48 object-cover rounded-full shadow-lg" data-id="element-120" data-mp="2ibfz6bvq47v8" />
            </div>
            <div className="flex-1" data-id="element-121" data-mp="bj5flk7yfo2f">
              <h3 className="text-2xl font-bold text-dark mb-2" data-id="element-122" data-mp="bi3qwcy0n328">
                Andreina Escalante Prado
              </h3>
              <p className="text-primary font-semibold mb-4" data-id="element-123" data-mp="6n7w551ea1lf">Fundadora</p>
              <p className="text-gray-600 mb-6" data-id="element-124" data-mp="2hvwfhsoonwg8">
                Fundadora de Pancita Feliz Foundation y creadora de sus programas
                educativos. Durante 7 años acompañó de manera independiente a
                familias de niños neurodiversos, conectándolas con educación,
                profesionales y recursos especializados. Hoy lidera la fundación
                para ampliar ese impacto mediante una estructura transparente y
                sostenible.
              </p>
              <div className="bg-primary/5 rounded-xl p-6 border-l-4 border-primary" data-id="element-125" data-mp="237t6eafcg4n7">
                <QuoteIcon className="w-8 h-8 text-primary mb-3" data-id="element-126" data-mp="285l11c7di4v3" />
                <p className="text-dark italic" data-id="element-127" data-mp="2cxl6tla4jrzl">
                  "Cada familia merece ser el superhéroe de su propia historia.
                  Nuestro trabajo es darles las herramientas para lograrlo."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}